import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import TransactionModel from '../../models/TransactionModel';
import AppNotification from "../../helpers/AppNotification";
import Paginate from "../paginate/Paginate";
import ModalTransactionEdit from './ModalTransactionEdit';
import { RiHistoryLine, RiEdit2Line, RiCloseLine } from "react-icons/ri";

function ModalHistory(props) {
    const [showFormEdit, setShowFormEdit] = useState(false);
    const [hasChangeData, setHasChangeData] = useState(false);
    const [dataEdit, setDataEdit] = useState({});
    const [data, setData] = useState([]);
    const [canView, setCanView] = useState(false);
    const [perPage] = useState(5);
    const [page, setPage] = useState(1);
    const [meta, setMeta] = useState({});

    const changePage = (newPage) => {
        setPage(newPage);
    };
    const handleSetPage = (number) => {
        setPage(page + number);
    };

    useEffect(() => {
        if (!props.data || !props.data.id) return;
        TransactionModel.getHistory({
            id: props.data.id,
            page: page,
            perPage: perPage
        }).then((res) => {
            setData(res.data || []);
            setMeta(res.meta || {});
            setHasChangeData(false);
            setCanView(res.meta && res.meta.can_view_app_history === 1);
        }).catch((err) => {
            console.log(err);
            AppNotification.showError('Lấy dữ liệu thất bại!');
        });
    }, [props.data, page, hasChangeData, props.show, perPage]);

    const handleModalEdit = (item) => {
        setDataEdit(item);
        setShowFormEdit(true);
    };

    const handleCloseModalEdit = () => {
        setDataEdit({});
        setShowFormEdit(false);
        setHasChangeData(false);
    };

    const handleCloseModalEditReload = () => {
        setHasChangeData(true);
        setShowFormEdit(false);
    };

    return (
        <>
            <Modal
                {...props}
                size="xl"
                className={showFormEdit ? "blur" : ""}
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter" className="d-flex align-items-center gap-2">
                        <RiHistoryLine size={18} style={{ color: 'var(--wus-text)' }} />
                        <span>Lịch Sử Giao Dịch Trên App</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {canView ? (
                        <div className="table-responsive">
                            <table className="table bank-table mb-3" style={{ width: '100%' }}>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Người gửi</th>
                                        <th>Người nhận</th>
                                        <th>Ngân hàng</th>
                                        <th>Thời gian</th>
                                        <th>Mã GD</th>
                                        <th className="text-end">Số tiền</th>
                                        <th>Nội dung</th>
                                        <th className="text-center">Thao tác</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.length > 0 ? data.map((item, key) => {
                                        const isIncoming = item.type === "APPTRANSFERAPP";
                                        return (
                                            <tr key={key}>
                                                <td className="font-monospace" style={{ color: 'var(--wus-text-subtle)' }}>{(page - 1) * perPage + key + 1}</td>
                                                <td>
                                                    <div style={{ fontWeight: 600, color: 'var(--wus-text)' }}>{item.from_name}</div>
                                                    <div className="font-monospace" style={{ fontSize: '12px', color: 'var(--wus-text-subtle)' }}>{item.from_number}</div>
                                                </td>
                                                <td>
                                                    <div style={{ fontWeight: 600, color: 'var(--wus-text)' }}>{item.recipient_name}</div>
                                                    <div className="font-monospace" style={{ fontSize: '12px', color: 'var(--wus-text-secondary)' }}>{item.recipient_account_number}</div>
                                                </td>
                                                <td><span className="bank-type-badge">{item.bank_code_id}</span></td>
                                                <td className="font-monospace" style={{ fontSize: '12px', color: 'var(--wus-text-muted)' }}>{item.created_at_fm}</td>
                                                <td className="font-monospace" style={{ fontSize: '12px', color: 'var(--wus-text-subtle)' }}>{item.transaction_code}</td>
                                                <td className="text-end font-monospace" style={{ fontWeight: 700, color: isIncoming ? 'var(--wus-success-text)' : 'var(--wus-danger-text)' }}>
                                                    {isIncoming ? '+' : '-'}{parseInt(item.amount || 0).toLocaleString("en-US")} đ
                                                </td>
                                                <td style={{ maxWidth: '220px', fontSize: '12.5px', color: 'var(--wus-text-secondary)' }}>{item.transaction_note || item.note}</td>
                                                <td className="text-center">
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary btn-sm"
                                                        title="Chỉnh sửa giao dịch"
                                                        onClick={() => handleModalEdit(item)}
                                                    >
                                                        <RiEdit2Line size={14} />
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    }) : (
                                        <tr>
                                            <td colSpan={9} className="text-center py-4 text-muted">
                                                Chưa có lịch sử giao dịch nào cho tài khoản này.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <Paginate meta={meta} changePage={changePage} page={page} handleSetPage={handleSetPage} />
                        </div>
                    ) : (
                        <div className="text-center py-4">
                            <p className="mb-0 text-muted">Vui lòng liên hệ Admin để kích hoạt quyền xem và chỉnh sửa lịch sử giao dịch App.</p>
                        </div>
                    )}
                </Modal.Body>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={props.onHide}>
                        <RiCloseLine className="me-1" size={16} />
                        Đóng
                    </button>
                </div>
            </Modal>
            <ModalTransactionEdit
                show={showFormEdit}
                onHide={() => handleCloseModalEdit()}
                onHideReload={() => handleCloseModalEditReload()}
                data={dataEdit}
                reloadPage={props.reloadPage}
            />
        </>
    );
}

export default ModalHistory;